<template>
    <div class="expander-text" :class="{open: isOpen}">

        <b-collapse
            aria-id="contentIdForA11y2"
            animation="slide"
            v-model="isOpen">
            <template #trigger>
                <div role="button">
                    <div class="expander-header is-flex">
                        <div class="ml-4 is-flex-grow-1">
                            <h4 :class="{open: isOpen}">{{content.title}}</h4>
                        </div>
                        <div class="pt-1 pl-5 pr-2">
                            <i class="fal" :class="{'fa-plus-large': !isOpen, 'fa-dash': isOpen}"></i>
                        </div>
                    </div>
                </div>
            </template>

            <div>
                <render-editor-js :content="content.content" :component="{}"/>
            </div>
        </b-collapse>

    </div>
</template>

<script>
    import RenderEditorJs from "./RenderEditorJs";

    export default {
        components: {RenderEditorJs},
        props: ['content'],
        data: function() {
            return {
                isOpen: false
            }
        }
    };
</script>

<style scoped lang="scss">
    .expander-text {
        border-left: 3px solid transparent;
        padding-bottom: 10px;
        border-radius: 6px;
        margin: 2rem 0;

        &.open {
            border-color: #666;
        }

        .expander-header {
            padding: 10px;

            h4 {

                border-bottom: 1px solid #e7e7e7;
                padding-bottom: 1rem;
                margin-bottom: 1rem;

            }

            i {
                font-size: 20px;
            }
        }
    }
</style>
